import { useEffect } from 'react';
export const PIXEL_ID = '1077170091803506';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: unknown;
      queue?: unknown[];
    };
    _fbq?: unknown;
  }
}

/** Meta Pixel — loads fbevents.js once and tracks PageView. */
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return; /* eslint-disable */
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) s.parentNode.insertBefore(t, s);else b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-3" data-mp="kq60nu985pxu">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-4" data-mp="koleot0z7fbl" />
    </noscript>;
}
export function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    value: 19990,
    currency: 'ARS'
  });
}